export default function Alert({ title, message, type = "error", children }) {
  const baseStyles = "p-4 mb-4 text-sm rounded-lg";
  const errorStyles = "text-red-800 dark:text-red-300 bg-red-50 dark:bg-red-950/40";
  const successStyles = "text-green-800 dark:text-green-300 bg-green-50 dark:bg-green-950/40";

  const alertStyles = type === "error" ? errorStyles : successStyles;

  return (
    <div className={`${baseStyles} ${alertStyles}`} role="alert">
      <p className="font-medium">{title} </p>
      <p className={`${alertStyles}`}>{message}</p>
      {children}
    </div>
  );
}
